import { CoordinatorService } from "./coordinator.service"


export class Search {
    id: string

    constructor(private coords: CoordinatorService) {
        this.id = this.coords.uniqueId()
    }
}
